
import clientAxios from "../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType } from "@/common/types/common";

export async function collectionTagList(
    collection_id: string,
    query?: QueryType
) {
    const queryString = formatQueryString(query);

    return await clientAxios.get(
        `collection/${collection_id}/tag/list${queryString}`
    );
}

export async function collectionTagGet(
    item_id: string
) {
    return await clientAxios.get(
        `collection/tag/${item_id}/show`
    );
}

export async function collectionTagCreate(
    collection_id: string,
    tag_id: string
) {
    return await clientAxios.post(
        `collection/${collection_id}/tag/create`,
        { tag_id }
    );
}

export async function collectionTagDel(
    item_id: string,
) {
    return await clientAxios.del(
        `collection/tag/${item_id}/delete`,
    );
}
